import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import { parse, getPhoneCode } from 'libphonenumber-js';
import _omit from 'lodash/omit';
// Core components
import TextField from 'components/core/TextField';
import Typography from 'components/core/Typography';
import Tooltip from 'components/core/Tooltip';
// Custom
import { InfoIconButton } from 'components/buttons/IconButtons';
import CountrySelector from './CountrySelector';

const formatPrefix = (code) => `+${getPhoneCode(code)}`;

class PhoneNumberInputField extends React.Component {
  constructor(props) {
    super(props);

    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.handleNumberChange = this.handleNumberChange.bind(this);

    const { countryCode } = this.props;
    this.state = {
      localNumber: '',
      localCountryCodeISO: countryCode,
    };
  }

  // Handlers
  handleCountryChange(code) {
    this.setState(
      {
        localCountryCodeISO: code,
      },
      () => this.doHandleChange({ prefix: formatPrefix(code) }),
    );
  }

  handleNumberChange(number) {
    this.setState(
      {
        localNumber: number,
      },
      () => this.doHandleChange({ number }),
    );
  }

  // Private
  doHandleChange({ prefix, number }) {
    const { onChange } = this.props;
    const { localNumber, localCountryCodeISO } = this.state;

    const builtPrefix = prefix || formatPrefix(localCountryCodeISO);
    const builtNumber = number || localNumber || '';

    // Build phone
    const phone = builtNumber === '' ? '' : builtPrefix + builtNumber;
    onChange(phone);
  }

  render() {
    const {
      labelId, value, required, infoLabelId, disabled, forceCountryCode, ...otherProps
    } = this.props;
    const { localNumber, localCountryCodeISO } = this.state;
    // Build phone number from value
    const parsedValue = parse(value);
    const countryCode = parsedValue.country || localCountryCodeISO;
    const prefix = formatPrefix(countryCode);
    const number = parsedValue.phone || localNumber;

    return (
      <TextField
        value={number}
        label={<LocalizedMessage id={labelId || 'field.number'} />}
        required={required}
        disabled={disabled}
        adornments={{
          start: (
            <div className="d-flex align-items-center" style={{ paddingBottom: 1 }}>
              <CountrySelector countriesScope="all" disabled={forceCountryCode} value={countryCode} onChange={this.handleCountryChange} />
              <Typography type="adornment" className="ml-1">
                {prefix}
              </Typography>
            </div>
          ),
          end: infoLabelId ? (
            <Tooltip content={<LocalizedMessage id={infoLabelId} />}>
              <InfoIconButton />
            </Tooltip>
          ) : null,
        }}
        onChange={this.handleNumberChange}
        {..._omit(otherProps, ['dispatch', 'countryCode', 'onChange'])}
      />
    );
  }
}

PhoneNumberInputField.propTypes = {
  labelId: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  countryCode: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  infoLabelId: PropTypes.string,
  forceCountryCode: PropTypes.bool,
};

PhoneNumberInputField.defaultProps = {
  labelId: null,
  value: null,
  required: false,
  disabled: false,
  infoLabelId: null,
  forceCountryCode: false,
};

const mapStateToProps = (state) => ({
  countryCode: state.intl.countryCode,
});

module.exports = connect(mapStateToProps, null)(PhoneNumberInputField);



// WEBPACK FOOTER //
// ./components/inputFields/PhoneNumberInputField.js